<template>
    <section id="app-footer" class="uk-section uk-section-muted uk-section-small">
        <div class="uk-container">
            <div class="uk-text-center">
                ©{{ new Date().getFullYear() }}, Landon Road Photographers
            </div>
        </div>
    </section>
</template>

<script>
export default {
    data() {
        return {
            //
        }
    },
};
</script>

<style></style>
